module.exports = __webpack_public_path__ + "media/images/flags/er-bd37ee55de795aaa26279684f6db0a2b.svg";